import { Container } from '@mui/system';
import { useNavigate } from 'react-router-dom';
import {
    Box,
    Button,
    ImageList,
    ImageListItem,
    Stack,
    Typography,
    useMediaQuery,
    useTheme
} from '@mui/material';
import ArrowRightWhiteIconBold from '../../assets/icons/ArrowRightWhiteIconBold';
import yellowMobile from '../../assets/Images/YellowLogoIconMobile.webp';
import yellowLogo from '../../assets/Images/YellowLogoIcon.webp';

function FooterCallToAction() {
    const navigate = useNavigate();
    const theme = useTheme();
    const mobile = useMediaQuery(theme.breakpoints.down('lg'));
    const medium = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <Stack
            width={'100%'}
            sx={{
                backgroundColor: '#05668D',
                backgroundSize: '100%',
                height: mobile ? undefined : '274px',
                px: { xs: '16px', sm: '20px', lg: '40px' }
            }}
        >
            <Container
                maxWidth="xl"
                disableGutters
                sx={{
                    display: 'flex',
                    maxWidth: '100%',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    gap: '32px',
                    margin: medium ? '40px 0px' : undefined,
                    marginTop: medium ? undefined : '20px'
                }}
            >
                <Box
                    maxWidth={'xl'}
                    sx={{
                        display: 'flex',
                        flexDirection: mobile ? 'column-reverse' : 'row',
                        alignItems: mobile ? 'flex-start' : 'center',
                        justifyContent: 'space-between',
                        gap: mobile ? '8px' : '0',
                        mx: mobile ? '16px' : 0,
                        mt: mobile ? '0px' : 0
                    }}
                >
                    <Typography
                        sx={{
                            fontFamily: 'CabinetGrotesk-Variable',
                            fontWeight: 700,
                            fontSize: mobile ? '24px' : '44px',
                            lineHeight: mobile ? '28px' : '66px',
                            color: '#FFFFFF'
                        }}
                    >
                        Want to join us on this {medium ? <br></br> : null}{' '}
                        exhilarating journey
                    </Typography>
                    <ImageList
                        onClick={() => {
                            navigate('/');
                        }}
                        sx={{
                            transition: 'all .4s ease',
                            cursor: 'pointer',
                            '&:hover': {
                                opacity: 0.8
                            }
                        }}
                        cols={1}
                    >
                        <ImageListItem>
                            {mobile ? (
                                <img src={yellowMobile} alt="logo" />
                            ) : (
                                <img src={yellowLogo} alt="logo" />
                            )}
                        </ImageListItem>
                    </ImageList>
                </Box>
                <a rel="noopener noreferrer" href="/create-account">
                    <Button
                        sx={{
                            height: mobile ? '60px' : '91px',
                            width: '100%',
                            color: '#FFFFFF',
                            border: '4px solid #FFFFFF',
                            borderRadius: '100px',
                            fontFamily: 'Outfit',
                            fontSize: mobile ? '20px' : '24px',
                            fontWeight: 700,
                            lineHeight: '28px',
                            letterSpacing: '0.02em',
                            gap: '20px'
                        }}
                    >
                        Create Account
                        <ArrowRightWhiteIconBold />
                    </Button>
                </a>
            </Container>
        </Stack>
    );
}

export default FooterCallToAction;
